import { subscribe, unsubscribe } from '@wh/message-bus'; //TODO change to @sb/message-bus once problem fixed with this package deploying and remove ts-ignore
import { isTrackingDataMatch } from './isTrackingDataMatch';
import { MB_TRACK_COMPLETED } from '../consts';
export const whenTrackCompleted = ({ resolve, timeout, trackData }) => {
    const token = subscribe(MB_TRACK_COMPLETED, (_, { data: trackCompletedData }) => {
        // compare tracking events payload to determine if the adapter managed to finish its work.
        if (isTrackingDataMatch({ trackData, trackCompletedData })) {
            clearTimeout(timeout);
            resolve();
        }
        unsubscribe(token);
    });
};
